// src/v3/logos/syncfy.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx, jsxs } from "react/jsx-runtime";
var SyncfyLogo = (props) => /* @__PURE__ */ jsxs(SvgIcon, { "data-testid": "SyncfyLogo", viewBox: "0 0 32 32", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.54836 8.54102C7.73897 8.53707 7.89369 8.40548 7.89369 8.24228V7.29327C7.89369 7.13157 7.74161 6.99956 7.55269 7C6.10053 7.00338 5.06517 7.14646 4.39563 7.6051C3.67482 8.09888 3.35682 8.92183 3.35682 10.2934V13.8413C3.35682 13.9693 3.29322 14.2802 3.10241 14.5545C2.95327 14.7832 2.71343 14.9784 2.34241 15.0527C2.15678 15.0899 2 15.2171 2 15.3804V16.2632C2 16.4221 2.14909 16.5479 2.32861 16.5884C2.70749 16.6738 2.95142 16.8794 3.10241 17.0965C3.29322 17.3891 3.35682 17.6634 3.35682 17.7915V21.3393C3.35682 22.7109 3.67482 23.5338 4.39563 24.0276C5.06517 24.4863 6.10053 24.6293 7.55269 24.6327C7.74156 24.6331 7.89369 24.5011 7.89369 24.3394V23.3904C7.89369 23.2272 7.73897 23.0957 7.54836 23.0917C6.82363 23.0766 6.31415 23.0039 5.96446 22.7657C5.56165 22.4914 5.39205 22.0708 5.39205 21.3393V17.7915C5.39205 17.0232 5.07383 16.5056 4.51563 16.094C4.32364 15.9524 4.32659 15.684 4.52008 15.544C5.07552 15.1419 5.39205 14.6222 5.39205 13.8413V10.2934C5.39205 9.56191 5.56165 9.14128 5.96446 8.86696C6.31415 8.62882 6.82363 8.55607 7.54836 8.54102ZM28.8976 14.5546C28.7068 14.2803 28.6432 13.9694 28.6432 13.8413V10.2935C28.6432 8.9219 28.3464 8.09895 27.6256 7.60517C26.956 7.14649 25.9022 7.00343 24.4473 7.00007C24.2584 6.99963 24.1063 7.13164 24.1063 7.29334V8.24235C24.1063 8.40555 24.261 8.53714 24.4516 8.5411C25.1764 8.55614 25.6859 8.62889 26.0355 8.86704C26.4384 9.14136 26.6079 9.56198 26.6079 10.2935V13.8413C26.6079 14.6223 26.9245 15.142 27.4799 15.5441C27.6734 15.6841 27.6763 15.9525 27.4844 16.0941C26.9262 16.5057 26.6079 17.0233 26.6079 17.7915V21.3394C26.6079 22.0709 26.4384 22.4915 26.0355 22.7659C25.6859 23.004 25.1764 23.0767 24.4516 23.0918C24.261 23.0957 24.1063 23.2273 24.1063 23.3905V24.3395C24.1063 24.5012 24.2584 24.6333 24.4473 24.6328C25.9022 24.6294 26.956 24.4864 27.6256 24.0277C28.3464 23.5339 28.6432 22.711 28.6432 21.3394V17.7915C28.6432 17.6635 28.7068 17.3892 28.8976 17.0966C29.0486 16.8795 29.2925 16.6739 29.6714 16.5884C29.8509 16.548 30 16.4222 30 16.2633V15.3804C30 15.2172 29.8432 15.09 29.6576 15.0528C29.2866 14.9785 29.0468 14.7833 28.8976 14.5546Z",
      fill: "#6C7179"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23 11.849C23 12.5794 22.4602 13.1714 21.7942 13.1714H14.2058C13.5398 13.1714 13 12.5794 13 11.849C13 11.1187 13.5398 10.5266 14.2058 10.5266H21.7942C22.4602 10.5266 23 11.1187 23 11.849Z",
      fill: "#F54376"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23 16.2573C23 16.9876 22.4878 17.5797 21.8561 17.5797H18.1439C17.5121 17.5797 17 16.9876 17 16.2573C17 15.5269 17.5121 14.9348 18.1439 14.9348H21.8561C22.4878 14.9348 23 15.5269 23 16.2573Z",
      fill: "#B287EE"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 16.2573C11 16.9876 10.4879 17.5797 9.85615 17.5797H9.14385C8.51213 17.5797 8 16.9876 8 16.2573C8 15.5269 8.51213 14.9348 9.14385 14.9348H9.85615C10.4879 14.9348 11 15.5269 11 16.2573Z",
      fill: "#6ADDCE"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23 20.6655C23 21.3958 22.4879 21.9879 21.8561 21.9879H21.1439C20.5121 21.9879 20 21.3958 20 20.6655C20 19.9351 20.5121 19.343 21.1439 19.343H21.8561C22.4879 19.343 23 19.9351 23 20.6655Z",
      fill: "#6690FF"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 20.6655C15 21.3958 14.4025 21.9879 13.6655 21.9879H9.33449C8.59749 21.9879 8 21.3958 8 20.6655C8 19.9351 8.59749 19.343 9.33449 19.343H13.6655C14.4025 19.343 15 19.9351 15 20.6655Z",
      fill: "#FFC22C"
    }
  )
] });

export {
  SyncfyLogo
};
